import { render } from "./PrivacyV20250611.vue?vue&type=template&id=28478420&scoped=true"
const script = {}

import "./PrivacyV20250611.vue?vue&type=style&index=0&id=28478420&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28478420"]])

export default __exports__